var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.48,
    height: 20.596,
    viewBox: "0 0 21.48 20.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-right",
    d: "M9.133,39.03,10.2,37.983a1.159,1.159,0,0,1,1.625,0l9.32,9.164a1.114,1.114,0,0,1,0,1.6l-9.32,9.169a1.159,1.159,0,0,1-1.625,0L9.133,56.867a1.12,1.12,0,0,1,.019-1.618l5.777-5.414H1.151A1.139,1.139,0,0,1,0,48.7V47.194a1.139,1.139,0,0,1,1.151-1.132H14.929L9.152,40.647A1.112,1.112,0,0,1,9.133,39.03Z",
    transform: "translate(21.48 58.246) rotate(180)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftB);
export default __webpack_public_path__ + "static/media/arrow-leftB.98a7bc46.svg";
export { ForwardRef as ReactComponent };